module.exports = "/_next/static/images/3cad6d9fd0e693134ca8483a7fcc56df-rewards-illustration@0.75x.png";